import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { CloseSurveyRPC } from "./closeSurveyRPC";

export class CloseSurveyRPCClientImpl extends CloseSurveyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: CloseSurveyRPC.Request): Promise<LeoRPCResult<CloseSurveyRPC.Response, CloseSurveyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/CloseSurvey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      CloseSurveyRPC.ResponseDTO,
      CloseSurveyRPC.Errors.ErrorsDTO,
      CloseSurveyRPC.Response,
      CloseSurveyRPC.Errors.Errors
    >(
      response,
      "survey/CloseSurvey",
      CloseSurveyRPC.Response.fromDTO,
      CloseSurveyRPC.Errors.fromDTO
    );
  }
}
